<template>
  <div
    class="column items-center justify-center full-width full-height tw-font-inter auth-page"
    :style="{ backgroundImage: `url(${loginBg}), linear-gradient(to bottom right, #EDF3F9, #F3F7FA, #DAE6F0)` }"
  >
    <div class="tw-w-full tw-max-w-[380px] tw-px-4">
      <div
        v-if="retrySecs > 0 || isLogged"
        class="flex full-width items-center justify-center"
      >
        <q-card
          flat
          class="tw-w-full tw-rounded-2xl tw-bg-white tw-border tw-border-solid tw-border-line tw-shadow-[0_16px_48px_-16px_rgba(23,105,182,0.25)]"
        >
          <q-card-section>
            <div class="text-h6">
              {{ load.loadType }}
            </div>
          </q-card-section>

          <q-separator inset />

          <q-card-section class="q-pt-none">
            <q-linear-progress
              dark
              size="5px"
              rounded
              indeterminate
              color="primary"
              class="q-mt-sm"
            />
          </q-card-section>
        </q-card>
      </div>

      <q-card
        v-else
        flat
        class="tw-w-full tw-rounded-2xl tw-bg-white tw-border tw-border-solid tw-border-line tw-shadow-[0_16px_48px_-16px_rgba(23,105,182,0.25)]"
      >
        <form
          @submit.prevent="handleAuth"
          @keyup.enter="handleAuth"
        >
          <q-card-section class="tw-px-8 tw-pt-8 tw-pb-7">
            <div class="column">
              <div class="tw-mx-auto tw-mb-5 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-primary/10">
                <VonixLogo class="tw-h-6" />
              </div>

              <h1 class="tw-m-0 tw-text-center tw-text-xl tw-font-bold tw-leading-7 tw-text-bluegrey-10">
                Olá! Você está no VonixPhone
              </h1>

              <p class="tw-mt-1 tw-mb-7 tw-text-center tw-text-[13px] tw-text-gray-500">
                Entre para começar a atender
              </p>

              <label
                for="agent"
                class="col"
              >
                <span class="tw-block tw-mb-1.5 tw-text-[13px] tw-font-medium tw-text-bluegrey-8">
                  Matrícula (ID do Agente no VonixCC)
                </span>

                <input
                  data-testid="login-matricula"
                  id="agent"
                  type="text"
                  class="tw-w-full tw-h-11 tw-rounded-xl tw-border tw-border-solid tw-border-transparent tw-bg-greyc-4 tw-px-4 tw-text-[15px] tw-text-bluegrey-10 tw-outline-none tw-transition focus:tw-bg-white focus:tw-border-primary focus:tw-ring-4 focus:tw-ring-primary/10 placeholder:tw-text-bluegrey-10/40"
                  placeholder="####"
                  v-model="agent"
                  maxlength="6"
                  @keypress="isNumber($event)"
                >
              </label>

              <label
                for="password"
                class="col tw-mt-4"
              >
                <span class="tw-block tw-mb-1.5 tw-text-[13px] tw-font-medium tw-text-bluegrey-8">
                  Senha
                </span>

                <input
                  id="password"
                  type="password"
                  class="tw-w-full tw-h-11 tw-rounded-xl tw-border tw-border-solid tw-border-transparent tw-bg-greyc-4 tw-px-4 tw-text-[15px] tw-text-bluegrey-10 tw-outline-none tw-transition focus:tw-bg-white focus:tw-border-primary focus:tw-ring-4 focus:tw-ring-primary/10 placeholder:tw-text-bluegrey-10/40"
                  placeholder="******"
                  v-model="password"
                  minlength="6"
                  @keypress="isNumber($event)"
                >
              </label>

              <div
                v-if="missingDevices.length"
                data-testid="login-aviso-dispositivos"
                class="col tw-mt-5 tw-flex tw-gap-2 tw-rounded-xl tw-border tw-border-solid tw-border-negative/30 tw-bg-negative/5 tw-p-3 tw-text-[13px] tw-text-negative"
              >
                <q-icon
                  name="mdi-headset-off"
                  size="18px"
                  class="tw-mt-px"
                />
                <div>
                  <div class="tw-font-medium">
                    {{ micDenied ? 'Microfone bloqueado' : 'Headset não configurado' }}
                  </div>
                  <div class="tw-text-bluegrey-8">
                    {{ missingDevicesText }}
                    <router-link
                      v-if="!micDenied"
                      data-testid="login-aviso-dispositivos-configurar"
                      :to="{ name: ROUTE_SETTINGS }"
                      class="tw-text-primary"
                    >
                      Configurar
                    </router-link>
                  </div>
                </div>
              </div>

              <div class="col tw-mt-6">
                <q-btn
                  data-testid="login-entrar"
                  unelevated
                  no-caps
                  :loading="isLoading"
                  :disable="disable || isLoading || isMicMissing"
                  @click="handleAuth"
                  label="Entrar"
                  color="primary"
                  class="full-width tw-h-11 tw-rounded-md tw-text-[15px] tw-font-medium tw-bg-primary tw-shadow-md tw-transition-all tw-duration-200 hover:tw-bg-primary-hover hover:tw-shadow-lg active:tw-scale-95"
                />
              </div>

              <span
                class="tw-mt-4 tw-text-center tw-text-[13px] tw-text-destructive"
                v-if="cognitoError && !isLoading"
              >
                {{ cognitoError }}
              </span>
            </div>
          </q-card-section>
        </form>
      </q-card>

      <div
        class="tw-mt-5"
        v-if="showSettings"
      >
        <div class="row items-center justify-between">
          <router-link
            data-testid="login-configuracoes"
            :to="{ name: ROUTE_SETTINGS }"
            class="col-auto tw-no-underline tw-rounded-full tw-bg-white/75 tw-backdrop-blur-sm tw-px-3 tw-py-1 tw-shadow-sm tw-text-[13px] tw-text-primary tw-transition hover:tw-bg-white"
          >
            <span>Ver configurações</span>
          </router-link>

          <div class="col-auto tw-rounded-full tw-bg-white/75 tw-backdrop-blur-sm tw-px-3 tw-py-1 tw-shadow-sm tw-text-xs tw-text-bluegrey-10/80">
            VP: <b>{{ version }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { ROUTE_SETTINGS } from '@/router/constants'
import VonixLogo from '@/assets/icons/vonixLogo.svg'
import loginBg from '@/assets/login-bg.jpg'
import { getVersion } from '@/libs/version'
import { findMissingAudioDevices, listAudioDevices, onAudioDevicesChange } from '@/libs/audioDevices'

export default {
  components: {
    VonixLogo
  },

  data () {
    return {
      agent: '',
      password: '',
      loginBg,
      version: getVersion(),
      missingDevices: [],
      micDenied: false,
      ROUTE_SETTINGS
    }
  },

  mounted () {
    this.checkDevices()
    this.stopDeviceWatch = onAudioDevicesChange(this.checkDevices)
  },

  beforeDestroy () {
    this.stopDeviceWatch?.()
  },

  computed: {
    ...mapGetters({
      cognitoError: 'authModule/cognitoError',
      retrySecs: 'sipModule/retrySecs',
      isLogged: 'authModule/isLogged',
      isLoading: 'authModule/isLoading'
    }),

    ...mapState({
      load: ({ agentModule }) => {
        let loadType = agentModule?.session?.loadType ?? ''
        if (!loadType) loadType = 'Carregando'

        if (loadType === 'sip') loadType = 'Conectando Ramal'
        if (loadType === 'sipDisconnect') loadType = 'Desconectando Ramal'
        if (loadType === 'logout') loadType = 'Deslogando Agente'
        if (loadType === 'session') loadType = 'Carregando dados do Agente'

        return { loadType }
      }
    }),

    disable () {
      return String(this.agent).trim().length < 4 || String(this.password).trim().length < 6
    },

    showSettings () {
      return !!(!this.isLogged && !this.isLoading)
    },

    isMicMissing () {
      return this.missingDevices.some(({ key }) => key === 'inputPhone')
    },

    missingDevicesText () {
      if (this.micDenied) return 'Permita o acesso ao microfone nas configurações do site e tente novamente.'
      const labels = this.missingDevices.map(({ label }) => label)
      const subject = labels.length > 1 ? `${labels.slice(0, -1).join(', ')} e ${labels[labels.length - 1]}` : labels[0]
      const ending = this.missingDevices.every(({ feminine }) => feminine) ? 'a' : 'o'
      const verb = labels.length > 1 ? `foram encontrad${ending}s` : `foi encontrad${ending}`
      return `${subject} não ${verb}.`
    }
  },

  methods: {
    ...mapActions({
      login: 'authModule/login'
    }),

    async checkDevices () {
      const devices = await listAudioDevices()
      this.micDenied = devices.micDenied
      this.missingDevices = findMissingAudioDevices(this.$store.state.settingsModule, devices)
    },

    handleAuth () {
      if (this.isLoading || this.isMicMissing) return
      const { agent, password } = this

      if (password.length < 6) {
        return this.$q.notify({
          message: 'A senha deve ter no mínimo 6 caracteres',
          color: 'negative',
          position: 'top'
        })
      }

      this.login({ agent, password })
    },

    isNumber: (evt) => {
      const charCode = evt.which ? evt.which : evt.keyCode
      const isNotNum = (charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46
      return isNotNum ? evt.preventDefault() : true
    }
  }
}
</script>

<style lang="sass" scoped>
.auth-page
  background-color: #EDF3F9
  background-position: center
  background-size: cover
  background-repeat: no-repeat
</style>
